var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pdf_area" } },
    [
      _vm.showQr
        ? [
            _c(
              "div",
              { staticClass: "message_area" },
              [
                _c("h3", [_vm._v("控え書面のご確認")]),
                _vm._v(
                  "\n      担当者に、こちらのタブレットをお渡しください。\n      "
                ),
                _c("el-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "el-oneTime", attrs: { id: "el-oneTime" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex", align: "middle", gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("p", { staticClass: "el-oneTime__text" }, [
                            _vm._v(
                              "\n              受付番号: " +
                                _vm._s(_vm.getHasContractId)
                            ),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm.getUserInputForm.surname +
                                  " " +
                                  _vm.getUserInputForm.first_name
                              ) + "様専用\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.oneTimeLoginUrl !== ""
                            ? _c(
                                "div",
                                { staticClass: "el-oneTime__qr" },
                                [
                                  _c("vue-qrcode", {
                                    attrs: {
                                      value: _vm.oneTimeLoginUrl,
                                      options: _vm.qrOptions,
                                      tag: "img"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", { staticClass: "el-oneTime__text limit" }, [
                            _vm._v(
                              "QRコードはお客様のスマートフォンですぐに読み取って下さい。"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "el-oneTime__text limit" }, [
                            _vm._v("有効期限: " + _vm._s(_vm.limit))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("p", { staticClass: "el-oneTime__explain" }, [
                            _vm._v(
                              "\n              表示されるQRコードは「ワンタイムQRコード」となります。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              本画面表示のQRコードは表示開始から60分間のみ有効です。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              必ず時間内にログインして頂きますようお願い致します。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              読み取り後、ホーム画面やお気に入り等に保存してください。"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              但し、QRコードからログインできない場合や控えの保存が正常に完了しない場合は、"
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              SMSにてお送りいたします「triplecrownマイページ」のURLよりご確認いただけます。\n            "
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "next" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-arrow-right" },
                    on: { click: _vm.nextPage }
                  },
                  [_vm._v("QRコード読み取りを確認し完了へ進む")]
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showPaper
        ? [
            _c(
              "div",
              { staticClass: "message_area" },
              [
                _c("h3", [_vm._v("控え書面の印刷")]),
                _vm._v(
                  "\n      担当者に、こちらのタブレットをお渡しください。\n      "
                ),
                _c("el-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("el-button", { on: { click: _vm.download } }, [
                      _c("i", { staticClass: "far fa-file-pdf" }),
                      _vm._v(" 控え書面をダウンロード")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "next" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", icon: "el-icon-arrow-right" },
                    on: { click: _vm.nextPage }
                  },
                  [_vm._v("控え書面をお渡しし完了へ進む")]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }